export type AnalyticsConsent = 'granted' | 'denied' | null;

const CONSENT_STORAGE_KEY = 'lagitfolio-analytics-consent';

const canUseStorage = (): boolean => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export const getAnalyticsConsent = (): AnalyticsConsent => {
  if (!canUseStorage()) return null;
  try {
    const value = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (value === 'granted' || value === 'denied') return value;
    return null;
  } catch {
    return null;
  }
};

export const setAnalyticsConsent = (consent: Exclude<AnalyticsConsent, null>) => {
  if (!canUseStorage()) return;
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, consent);
  } catch {
    // noop
  }
};

export const hasAnalyticsConsent = (): boolean => getAnalyticsConsent() === 'granted';
